import { PlayerEnvironment } from './player_environment';

export default class PlayerRetry {
  static isErrorIntercepted(errorCode) {
    return (window.playback.interceptedErrorCode != undefined && window.playback.interceptedErrorCode.includes(errorCode));
  }

  constructor({ tech, data } = {}) {
    this._tech = tech;
    this._data = data;
    this.maxError = 4; //3x retries + 1x blocker prompt
  }

  init() {
    this.vp9FailoverRetry();
    this.errorCode4Retry();
    this.errorCodeListener(window.playback.interceptedErrorCode);
  }

  vp9FailoverRetry() {
    if (this.data().isLivestreaming() && 
      !this.data().drmEnabled() &&
      this.data().vjsClipDashUrl() &&
      PlayerEnvironment.isSupportVp9() ) {
        this.appendInterceptedErrorCode([2, 3]);
    }
  }

  errorCode4Retry() {
    this.appendInterceptedErrorCode([4]);
  }

  errorCodeListener(errorCode) {
    if(errorCode == undefined) return;

    this.tech().on('error', () => {
      if(errorCode.includes(this.tech().errorCode())) {
        window.playback.restartCount = (window.playback.restartCount || 0) + 1;

        if (window.playback.restartCount < this.maxError) {
          this.tech().trigger('vp-restart');
        } else {
          window.playback.interceptedErrorCode = undefined;
        }
      }
    });
  }

  appendInterceptedErrorCode(array) {
    if(Array.isArray(window.playback.interceptedErrorCode)) {
      window.playback.interceptedErrorCode = window.playback.interceptedErrorCode.concat(array);
    } else {
      window.playback.interceptedErrorCode = array;
    }
  }

  tech() { return this._tech; }
  data() { return this._data; }
}
